<template>
	<div class="appDetailView">
		<div class="adv_btnArea">
			<div class="adv_ba_left">
				<span>{{ data.name }}</span>
			</div>
			<div class="adv_ba_right">
				<div @click="invitationBtn" v-if="['0', '1'].includes(data.status)">
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="#969BA3"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="mdi:invite">
							<path
								id="Vector"
								d="M15.8333 14.1667V15.8334H5.83333V14.1667C5.83333 14.1667 5.83333 10.8334 10.8333 10.8334C15.8333 10.8334 15.8333 14.1667 15.8333 14.1667ZM13.3333 6.66675C13.3333 6.1723 13.1867 5.68895 12.912 5.27782C12.6373 4.8667 12.2469 4.54627 11.79 4.35705C11.3332 4.16783 10.8306 4.11832 10.3456 4.21479C9.86065 4.31125 9.4152 4.54935 9.06557 4.89898C8.71593 5.24861 8.47783 5.69407 8.38137 6.17902C8.28491 6.66398 8.33442 7.16664 8.52363 7.62346C8.71285 8.08027 9.03328 8.47072 9.44441 8.74542C9.85553 9.02013 10.3389 9.16675 10.8333 9.16675C11.4964 9.16675 12.1323 8.90336 12.6011 8.43452C13.0699 7.96568 13.3333 7.32979 13.3333 6.66675ZM16 10.8834C16.4555 11.3037 16.8228 11.8104 17.0803 12.3742C17.3379 12.9379 17.4805 13.5473 17.5 14.1667V15.8334H20V14.1667C20 14.1667 20 11.2917 16 10.8834ZM15 4.16675C14.7482 4.16676 14.498 4.20613 14.2583 4.28342C14.7459 4.98256 15.0073 5.8144 15.0073 6.66675C15.0073 7.5191 14.7459 8.35094 14.2583 9.05008C14.498 9.12737 14.7482 9.16673 15 9.16675C15.663 9.16675 16.2989 8.90336 16.7678 8.43452C17.2366 7.96568 17.5 7.32979 17.5 6.66675C17.5 6.00371 17.2366 5.36782 16.7678 4.89898C16.2989 4.43014 15.663 4.16675 15 4.16675ZM6.66667 8.33342H4.16667V5.83342H2.5V8.33342H0V10.0001H2.5V12.5001H4.16667V10.0001H6.66667V8.33342Z"
							/>
						</g>
					</svg>

					<span>{{ lang.invitation }}</span>
				</div>

				<div @click="pauseBtn" v-if="data.status == '0'">
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"

            
						fill="#969BA3"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="material-symbols:pause-rounded">
							<path
								id="Vector"
								d="M13.3333 15.8334C12.875 15.8334 12.4828 15.6704 12.1567 15.3442C11.8306 15.0181 11.6672 14.6256 11.6667 14.1667V5.83342C11.6667 5.37508 11.83 4.98286 12.1567 4.65675C12.4833 4.33064 12.8756 4.16731 13.3333 4.16675C13.7911 4.16619 14.1836 4.32953 14.5108 4.65675C14.8381 4.98397 15.0011 5.37619 15 5.83342V14.1667C15 14.6251 14.8369 15.0176 14.5108 15.3442C14.1847 15.6709 13.7922 15.834 13.3333 15.8334ZM6.66667 15.8334C6.20833 15.8334 5.81611 15.6704 5.49 15.3442C5.16389 15.0181 5.00056 14.6256 5 14.1667V5.83342C5 5.37508 5.16333 4.98286 5.49 4.65675C5.81667 4.33064 6.20889 4.16731 6.66667 4.16675C7.12444 4.16619 7.51694 4.32953 7.84417 4.65675C8.17139 4.98397 8.33444 5.37619 8.33333 5.83342V14.1667C8.33333 14.6251 8.17028 15.0176 7.84417 15.3442C7.51806 15.6709 7.12556 15.834 6.66667 15.8334Z"
							/>
						</g>
					</svg>

					<span>{{ lang.pause }}</span>
				</div>

				<div @click="startBtn" v-if="data.status == '1'">
					<svg
						t="1749623939898"
						class="icon"
						viewBox="0 0 1024 1024"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						style="transform: scale(0.8)"
						p-id="4464"
						fill="#969BA3"
					>
						<path
							d="M380.677 176.279l390.182 225.272c85.024 49.089 85.024 171.81 0 220.899L380.677 847.721c-85.024 49.089-191.304-12.272-191.304-110.449V286.728c0-98.177 106.28-159.538 191.304-110.449z"
							p-id="4465"
						></path>
					</svg>
					<span>{{ lang.continue }}</span>
				</div>

				<div @click="stopBtn" v-if="['0', '1'].includes(data.status)">
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						class="stopSvg"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="heroicons-outline:stop">
							<g id="Group">
								<path
									id="Vector"
									d="M16 10C16 10.7879 15.8448 11.5681 15.5433 12.2961C15.2417 13.0241 14.7998 13.6855 14.2426 14.2426C13.6855 14.7998 13.0241 15.2417 12.2961 15.5433C11.5681 15.8448 10.7879 16 10 16C9.21207 16 8.43185 15.8448 7.7039 15.5433C6.97595 15.2417 6.31451 14.7998 5.75736 14.2426C5.20021 13.6855 4.75825 13.0241 4.45672 12.2961C4.15519 11.5681 4 10.7879 4 10C4 8.4087 4.63214 6.88258 5.75736 5.75736C6.88258 4.63214 8.4087 4 10 4C11.5913 4 13.1174 4.63214 14.2426 5.75736C15.3679 6.88258 16 8.4087 16 10Z"
									stroke="#969BA3"
									stroke-width="1.5"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
								<path
									id="Vector_2"
									d="M8 8.66667C8 8.48986 8.07024 8.32029 8.19526 8.19526C8.32029 8.07024 8.48986 8 8.66667 8H11.3333C11.5101 8 11.6797 8.07024 11.8047 8.19526C11.9298 8.32029 12 8.48986 12 8.66667V11.3333C12 11.5101 11.9298 11.6797 11.8047 11.8047C11.6797 11.9298 11.5101 12 11.3333 12H8.66667C8.48986 12 8.32029 11.9298 8.19526 11.8047C8.07024 11.6797 8 11.5101 8 11.3333V8.66667Z"
									fill="#969BA3"
									stroke="#969BA3"
									stroke-width="1.5"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</g>
						</g>
					</svg>

					<span>{{ lang.end }}</span>
				</div>
				<div @click="downloadBtn">
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="#969BA3"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="ic:round-download">
							<path
								id="Vector"
								d="M13.825 7.5H12.5V3.33333C12.5 2.875 12.125 2.5 11.6667 2.5H8.33335C7.87502 2.5 7.50002 2.875 7.50002 3.33333V7.5H6.17502C5.43335 7.5 5.05835 8.4 5.58335 8.925L9.40835 12.75C9.73335 13.075 10.2584 13.075 10.5834 12.75L14.4084 8.925C14.9334 8.4 14.5667 7.5 13.825 7.5ZM4.16669 15.8333C4.16669 16.2917 4.54169 16.6667 5.00002 16.6667H15C15.4584 16.6667 15.8334 16.2917 15.8334 15.8333C15.8334 15.375 15.4584 15 15 15H5.00002C4.54169 15 4.16669 15.375 4.16669 15.8333Z"
							/>
						</g>
					</svg>

					<span>{{ lang.download }}</span>
				</div>
				<!-- <div @click="groupingBtn">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="#969BA3"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="stash:user-group-duotone">
							<path
								id="Vector"
								opacity="0.5"
								d="M16 4.5C15.299 4.5 14.6268 4.77846 14.1311 5.27412C13.6355 5.76978 13.357 6.44203 13.357 7.143C13.357 7.84397 13.6355 8.51622 14.1311 9.01188C14.6268 9.50754 15.299 9.786 16 9.786C16.701 9.786 17.3732 9.50754 17.8689 9.01188C18.3645 8.51622 18.643 7.84397 18.643 7.143C18.643 6.44203 18.3645 5.76978 17.8689 5.27412C17.3732 4.77846 16.701 4.5 16 4.5ZM14.357 7.143C14.357 6.70725 14.5301 6.28935 14.8382 5.98122C15.1463 5.6731 15.5642 5.5 16 5.5C16.4357 5.5 16.8536 5.6731 17.1618 5.98122C17.4699 6.28935 17.643 6.70725 17.643 7.143C17.643 7.57875 17.4699 7.99665 17.1618 8.30478C16.8536 8.6129 16.4357 8.786 16 8.786C15.5642 8.786 15.1463 8.6129 14.8382 8.30478C14.5301 7.99665 14.357 7.57875 14.357 7.143ZM18.183 10.298C18.0254 10.2587 17.8608 10.2565 17.7022 10.2915C17.5436 10.3266 17.3953 10.3979 17.269 10.5C16.999 10.71 16.521 11 16 11C15.8674 11 15.7402 11.0527 15.6464 11.1464C15.5527 11.2402 15.5 11.3674 15.5 11.5C15.5 11.6326 15.5527 11.7598 15.6464 11.8536C15.7402 11.9473 15.8674 12 16 12C16.858 12 17.556 11.543 17.883 11.29C17.8951 11.2785 17.9099 11.2703 17.926 11.266H17.93C18.064 11.3013 18.197 11.3407 18.329 11.384L19.014 11.609C19.54 11.782 19.939 12.203 20.08 12.723L20.363 14.772C20.419 15.175 20.207 15.477 19.903 15.549C19.6797 15.6037 19.4087 15.657 19.09 15.709C19.0251 15.7195 18.963 15.7427 18.907 15.7772C18.8511 15.8117 18.8026 15.857 18.7641 15.9103C18.7257 15.9636 18.6981 16.0239 18.683 16.0879C18.6679 16.1518 18.6655 16.2181 18.676 16.283C18.6865 16.3479 18.7097 16.41 18.7442 16.466C18.7787 16.5219 18.824 16.5704 18.8773 16.6089C18.9306 16.6473 18.9909 16.6749 19.0549 16.69C19.1188 16.7051 19.1851 16.7075 19.25 16.697C19.5913 16.6403 19.886 16.582 20.134 16.522C21.029 16.309 21.467 15.452 21.354 14.635L21.063 12.529L21.056 12.502C20.9465 12.0738 20.7304 11.6803 20.428 11.3581C20.1255 11.0358 19.7464 10.7953 19.326 10.659L18.641 10.434C18.4897 10.3841 18.337 10.3388 18.183 10.298Z"
							/>
							<path
								id="Vector_2"
								d="M10 4.75C8.695 4.75 7.671 5.776 7.671 7C7.671 8.224 8.695 9.25 10 9.25C11.305 9.25 12.329 8.224 12.329 7C12.329 5.776 11.305 4.75 10 4.75ZM6.171 7C6.171 4.91 7.904 3.25 10 3.25C12.096 3.25 13.829 4.91 13.829 7C13.829 9.09 12.096 10.75 10 10.75C7.904 10.75 6.171 9.09 6.171 7ZM7.471 12.966C7.289 12.849 7.151 12.842 7.087 12.859C6.94366 12.899 6.801 12.9417 6.659 12.987L5.674 13.302C4.924 13.542 4.366 14.122 4.168 14.826L3.761 17.69C3.687 18.217 3.968 18.62 4.395 18.72C5.472 18.97 7.285 19.25 10 19.25C12.714 19.25 14.528 18.97 15.605 18.72C16.032 18.62 16.313 18.217 16.238 17.69L15.832 14.826C15.634 14.122 15.076 13.542 14.326 13.302L13.341 12.987C13.1992 12.9414 13.0565 12.8988 12.913 12.859C12.848 12.842 12.711 12.849 12.529 12.966C12.017 13.298 11.129 13.736 10 13.736C8.871 13.736 7.983 13.298 7.47 12.966M6.688 11.413C7.3 11.245 7.881 11.446 8.284 11.707C8.654 11.947 9.258 12.236 9.999 12.236C10.739 12.236 11.344 11.946 11.714 11.706C12.117 11.446 12.698 11.245 13.31 11.413C13.4733 11.4583 13.636 11.5067 13.798 11.558L14.782 11.874C16.015 12.268 16.97 13.247 17.292 14.487L17.303 14.527L17.723 17.479C17.89 18.659 17.237 19.88 15.943 20.18C14.745 20.458 12.817 20.75 9.999 20.75C7.181 20.75 5.253 20.458 4.054 20.18C2.76 19.88 2.108 18.66 2.275 17.479L2.695 14.528L2.705 14.487C3.028 13.247 3.983 12.268 5.215 11.874L6.2 11.558C6.362 11.5067 6.52466 11.4583 6.688 11.413Z"
							/>
						</g>
					</svg>

					<span>{{ lang.aiGroupList }}</span>
				</div> -->

				<div class="adv_b_btn" @click="back" v-if="isShowBack">
					<img src="@/assets/img/appCenter/home_icon.svg" alt="" />
					<!-- <img src="@/assets/img/appCenter/arrow_button_icon.svg" />
				<span>{{ lang.Return }}</span> -->
				</div>
			</div>
		</div>
		<div class="adv_main">
			<div class="adv_m_navBar">
        <span :class="{ navActive: tag == 2 }" @click="changeTag(2)">{{
					lang.students
				}}</span>

				<span :class="{ navActive: tag == 1 }" @click="changeTag(1)">{{
					lang.view_the_analysis_title
				}}</span>

        <span :class="{ navActive: tag == 0 }" @click="changeTag(0)">{{
					lang.application
				}}</span>
			</div>
			<div class="adv_m_panel" v-loading="loading">
				<div class="adv_m_panel_iframe" v-loading="iframeLoading" 	v-show="tag == 0">
					<iframe
						v-if="data.url"
						ref="iframeRef"
						:src="data.url"
						allow="camera *; microphone *;display-capture;midi;encrypted-media;"
						sandboxed="*"
						webkitallowfullscreen
						mozallowfullscreen
						allowfullscreen
						frameborder="0"
					></iframe>
				</div>
				<analysisCard
					v-show="tag == 1"
          :tag="tag"
          :obj="data"
          @changeTeachingModeAnalysis="updateTeachingModeAnalysis"
					ref="analysisCardRef"
				/>
				<studentCard
					v-show="tag == 2"
					:obj="data"
					ref="studentCardRef"
					@sendMessage="sendMessage"
					:isShowTest="isShowTest"
				/>
			</div>
		</div>
		<InvitationDialog ref="InvitationDialogRef" />
	</div>
</template>

<script>
import analysisCard from "../components/analysisCard.vue";
import studentCard from "../components/studentCard.vue";
import InvitationDialog from "../dialog/InvitationDialog.vue";
import * as Y from "yjs";
import { WebsocketProvider } from "y-websocket";
import { v4 as uuidv4 } from "uuid";
export default {
	components: {
		analysisCard,
		studentCard,
		InvitationDialog,
	},
	props: {
		id: {
			type: String,
			default: "",
		},
		isShowTest: {
			type: Boolean,
			default: false,
		},
		isShowBack: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			tag: 2, //0 应用 1 分析 2学生
			data: {
				url: "",
				name: "",
				stopStatus: 0, //0 正常运行  1 已停止
				pauseStatus: 0, //0 正常运行 1 已暂停
			},
			studentList: [],
			loading: false,
			btnLoading: false,
			iframeLoading: true,
      doc: null,
			provider: null,
			yMessage: null,
			mId: null,
		};
	},
	watch: {
		data: {
			handler(newVal) {
				if (newVal.url) {
					
					this.$nextTick(() => {
						let iframe = this.$refs.iframeRef;
						iframe.addEventListener("load", () => {
							console.log("iframe加载完毕");
							this.iframeLoading = false;
						});
					});
				}
			},
		},
	},
	methods: {
		back() {
			this.$parent.changeShowTag(0);
		},
		//分组
		groupingBtn() {
			this.$refs.studentCardRef.groupingBtn();
			//this.$message.info("分组");
		},
		//下载
		downloadBtn() {
			let _studentData = this.$refs.studentCardRef.studentList;
			let statusList = [
				this.lang.unfinished,
				this.lang.completed,
				this.lang.pause,
				this.lang.stop,
			];
			if (_studentData.length > 0) {
				let _array = [];

				_studentData.forEach((i, index) => {
					let _json = {};
					_json[this.lang.sequenceNumber] = index + 1;
					_json[this.lang.student_name] = i.name;
					_json[this.lang.summary] = i.summary ? i.summary : "-";
					if (i.nodeData.length > 0) {
						let _content = ``;
						i.nodeData.forEach((i2, index2) => {
							_content += `${this.lang.node + (index2 + 1)}：\n`;
							i2.messageList.forEach((i3) => {
								_content += `${i3.userName}：\n${i3.userContent}\n\n${i3.aiName}：\n${i3.aiContent}\n\n`;
							});
						});
						_json[this.lang.node] = _content;
					} else {
						_json[this.lang.node] = "-";
					}

					_json[this.lang.last_conversation] = i.lastChat ? i.lastChat : "-";

					_json[this.lang.task_status] = statusList[i.status];

					_array.push(_json);
				});

				let XLSX = require("xlsx");
				const workbook = XLSX.utils.book_new();
				let ws = XLSX.utils.json_to_sheet(_array);

				ws["!cols"] = [
					{ wch: "5" },
					{ wch: "20" },
					{ wch: "40" },
					{ wch: "100" },
					{ wch: "20" },
					{ wch: "20" },
				];
				XLSX.utils.book_append_sheet(workbook, ws, "sheet1"); //把sheet添加到workbook里，第三个参数是sheet名
				XLSX.writeFile(workbook, `${this.data.name}.xlsx`);
			} else {
				this.$message.info(this.lang.noData);
			}
		},
		//停止
		stopBtn() {
			if (!["0", "1"].includes(this.data.status) || this.btnLoading) return;
			this.$confirm(this.lang.confirmEndApp, this.lang.tip, {
				confirmButtonText: this.lang.queding,
				cancelButtonText: this.lang.cancel,
				type: "warning",
			})
				.then(() => {
					this.btnLoading = true;
					let params = [
						{
							uid: this.user.userId,
							tid: this.data.id,
							appId: this.data.appId,
							name: this.data.name,
							summary: this.data.summary,
							collaborative_teacher: this.data.collaborative_teacher,
							class_id: this.data.class_id,
							status: "2",
							analysis: JSON.stringify(this.data.analysis),
							json: JSON.stringify(this.data.tJson),
						},
					];

					this.ajax
						.post(this.$store.state.api + "update_teachingMode", params)
						.then((res) => {
							if (res.data == 1) {
								this.data.status = "2";
								this.$message.success(this.lang.modifiedSuccessfully);
								this.sendMessage({
									type: "changeAppData",
									id: this.data.id,
								});
							} else {
								this.$message.error(this.lang.modificationFailure);
							}
							this.btnLoading = false;
						})
						.catch((err) => {
							console.log(err);
							this.btnLoading = false;
							this.$message.error(this.lang.modificationFailure);
						});
				})
				.catch(() => {});
		},
		//暂停
		pauseBtn() {
			if (!["0"].includes(this.data.status) || this.btnLoading) return;
			this.btnLoading = true;
			let params = [
				{
					uid: this.user.userId,
					tid: this.data.id,
					appId: this.data.appId,
					name: this.data.name,
					summary: this.data.summary,
					collaborative_teacher: this.data.collaborative_teacher,
					class_id: this.data.class_id,
					status: "1",
					analysis: JSON.stringify(this.data.analysis),
					json: JSON.stringify(this.data.tJson),
				},
			];

			this.ajax
				.post(this.$store.state.api + "update_teachingMode", params)
				.then((res) => {
					if (res.data == 1) {
						this.data.status = "1";
						this.$message.success(this.lang.modifiedSuccessfully);
						this.sendMessage({
							type: "changeAppData",
							id: this.data.id,
						});
					} else {
						this.$message.error(this.lang.modificationFailure);
					}
					this.btnLoading = false;
				})
				.catch((err) => {
					console.log(err);
					this.btnLoading = false;
					this.$message.error(this.lang.modificationFailure);
				});
		},
		startBtn() {
			if (!["1"].includes(this.data.status) || this.btnLoading) return;
			this.btnLoading = true;
			let params = [
				{
					uid: this.user.userId,
					tid: this.data.id,
					appId: this.data.appId,
					name: this.data.name,
					summary: this.data.summary,
					collaborative_teacher: this.data.collaborative_teacher,
					class_id: this.data.class_id,
					status: "0",
					analysis: JSON.stringify(this.data.analysis),
					json: JSON.stringify(this.data.tJson),
				},
			];

			this.ajax
				.post(this.$store.state.api + "update_teachingMode", params)
				.then((res) => {
					if (res.data == 1) {
						this.data.status = "0";
						this.$message.success(this.lang.modifiedSuccessfully);
						this.sendMessage({
							type: "changeAppData",
							id: this.data.id,
						});
					} else {
						this.$message.error(this.lang.modificationFailure);
					}
					this.btnLoading = false;
				})
				.catch((err) => {
					console.log(err);
					this.btnLoading = false;
					this.$message.error(this.lang.modificationFailure);
				});
		},
		//邀请
		invitationBtn() {
			this.$refs.InvitationDialogRef.open(this.data);
		},
		//切换面板
		changeTag(newValue) {
			this.tag = newValue;
			if (this.tag === 2) {
				this.$refs.studentCardRef.getStudentList();
			}
		},
		//获取应用详细
		getData(flag=false) {
			if (!this.id) return;
			let params = {
				uid: this.user.userId,
				tid: this.id,
			};

			this.ajax
				.get(this.$store.state.api + "select_teachingModeById", params)
				.then((res) => {
					let _data = res.data[0];
					if (_data.length > 0) {
						let _result = _data[0];
						_result.appJson = _result.appJson
							? JSON.parse(_result.appJson)
							: {};
						_result.analysis = _result.analysis
							? JSON.parse(_result.analysis)
							: {};
						_result.tJson = _result.tJson && _result.tJson != 'undefined' ? JSON.parse(_result.tJson) : {};
						console.log(this.data, "=>", _result);
						this.data = _result;
						this.$forceUpdate();
						this.$nextTick(() => {
							this.$refs.studentCardRef.getStudentList();
              if(flag){
                this.connectYWebsocket();
              }
              
						});
					}
					this.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.$message.error(this.lang.data_failure);
					this.loading = false;
				});
		},
		//修改应用json
		updateTeachingModeJson(json){
			let params = [
			{
					uid: this.user.userId,
					tid: this.data.id,
					appId: this.data.appId,
					name: this.data.name,
					summary: this.data.summary,
					collaborative_teacher: this.data.collaborative_teacher,
					class_id: this.data.class_id,
					status: this.data.status,
					analysis: JSON.stringify(this.data.analysis),
					json: JSON.stringify(json),
				},
			];
			this.ajax.post(this.$store.state.api + "update_teachingMode", params).then(res => {
				if(res.data == 1){
					console.log("修改教学空间json完成")
					// this.$message.success(this.lang.modifiedSuccessfully);
				}else{
					// this.$message.error(this.lang.modificationFailure);
				}
			}).catch(err => {
				console.log(err);
				// this.$message.error(this.lang.modificationFailure);
			})
		},
      //修改应用分析
      updateTeachingModeAnalysis(json){
			let params = [
			{
					uid: this.user.userId,
					tid: this.data.id,
					appId: this.data.appId,
					name: this.data.name,
					summary: this.data.summary,
					collaborative_teacher: this.data.collaborative_teacher,
					class_id: this.data.class_id,
					status: this.data.status,
					analysis: JSON.stringify(json),
					json: JSON.stringify(this.data.tJson),
				},
			];
			this.ajax.post(this.$store.state.api + "update_teachingMode", params).then(res => {
				if(res.data == 1){
					console.log("修改教学空间json完成")
					// this.$message.success(this.lang.modifiedSuccessfully);
				}else{
					// this.$message.error(this.lang.modificationFailure);
				}
			}).catch(err => {
				console.log(err);
				// this.$message.error(this.lang.modificationFailure);
			})
		},
    // 优化yjs代码，不同步历史数据，只接收新消息
    messageInit() {
      if (this.doc && !this.yMessage) {
        // 获取Y.Array，但不同步历史消息
        this.yMessage = this.doc.getArray("message");
        // 只监听新增事件，忽略数组已有内容，不做预拉取
        this.yMessage.observe((e) => {
          // 只处理远端新增的消息（本地发的本地已知，不处理）
          // 注意：YJS在首次同步时会拉取整个Array历史，需手动忽略已有
          if (e.transaction.origin !== 'yjs-initial-load') {
            console.log("e.changes.added",e.changes.added)
            e.changes.added.forEach((i) => {
              const message = i.content.getContent()[0];
              // 跳过本地自己推送的消息
              if (message && message.mId !== this.mId) {
                this.getMessages(message);
              }
            });
          }
        });

        // 消除同步历史数据：只保留从连接后的数据，如果有历史，主动清除
        if (this.yMessage.length > 0) {
          this.doc.transact(() => {
            this.yMessage.delete(0, this.yMessage.length);
          }, 'yjs-initial-load');
        }
      }
    },
    sendMessage(obj) {
      if (this.doc && this.yMessage) {
        obj.timestamp = new Date().toISOString();
        obj.mId = this.mId;
        this.doc.transact(() => {
          this.yMessage.push([obj]);
        });
      }
    },
    getMessages(msgObj) {
      console.log("message", msgObj);
      let type = msgObj.type;
      if (["changeAppData"].includes(type)) {
        let id = msgObj.id;
        if (this.data.id === id) this.getData(false);
      }
      if (["changeTeachingWorks"].includes(type)) {
        if (this.data.id) {
          let id = msgObj.id;
          let tid = msgObj.tid;
          this.$refs.studentCardRef.updateStudentData(id, tid);
        }
      }
    },
    // 连接yWebsocket
    connectYWebsocket() {
      if (this.$store.state.yWebsocket && !this.doc && this.data.id) {
        this.doc = new Y.Doc();
        this.doc.gc = true;
        // 已同步标记，后续仅处理新的push
        console.log(`room：teachingSpace_${this.data.id}`);
        this.provider = new WebsocketProvider(
          this.$store.state.yWebsocket,
          `teachingSpace_${this.data.id}`,
          this.doc
        );
        this.provider.on("status", (event) => {
          console.log("👉", event.status);
          if (event.status == "connected") {
            console.log("👉连接成功websocket(teachingMode)");
            this.mId = uuidv4();
            this.messageInit();
          }
        });
      }
    }
	},
	mounted() {
		this.getData(true);

	},
};
</script>

<style lang="scss" scoped>
.appDetailView {
	width: 100%;
	height: auto;
	.adv_btnArea {
		width: 100%;
		height: 50px;
		margin: 15px 0 5px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.adv_ba_left {
			display: flex;
			align-items: center;
			width: 50%;
			height: 100%;
			span {
				font-size: 22px;
				font-weight: bold;
				display: block;
				width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
		.adv_ba_right {
			display: flex;
			align-items: center;

			justify-content: flex-end;
			width: 50%;
			height: 100%;
			div {
				padding: 5px 15px;
				background-color: #fff;
				border-radius: 20px;
				margin-left: 15px;
				box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
				cursor: pointer;
				display: flex;
				align-items: center;
				transition: 0.2s;
				white-space: nowrap;
				&:hover {
					background-color: #3681fc;
					color: #fff;
					svg {
						fill: #fff;
					}
					.stopSvg {
						g {
							path {
								stroke: #fff;
								&:nth-child(1) {
									fill: #3681fc;
								}
								&:nth-child(2) {
									fill: #fff;
								}
							}
						}
					}
				}
				svg {
					width: 20px;
					height: 20px;
					margin-right: 5px;
					transition: 0.2s;
				}
			}
			.adv_b_btn {
				background-color: #fff !important;
			}
		}
	}
	.adv_main {
		width: 100%;
		height: calc(100vh - 120px);
		.adv_m_navBar {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			box-sizing: border-box;
			border-bottom: solid 1px #e7e7e7;
			span {
				margin: 0 20px;
				cursor: pointer;
				transition: 0.2s;
				display: flex;
				height: 100%;
				align-items: center;
				position: relative;
				&:hover {
					color: #0560fd;
				}
			}
			.navActive {
				color: #0560fd;
				&::after {
					content: "";
					width: 100%;
					height: 3px;
					background-color: #0560fd;
					position: absolute;
					bottom: -1.5px;
				}
			}
		}
		.adv_m_panel {
			width: 100%;
			height: calc(100% - 50px);
			min-height: calc(100% - 50px);
			position: relative;
			// div{
			// 	width: 100%;
			// 	height: 100%;
			// 	background-color: red;
			// }
			.adv_m_panel_iframe{
				width: 100%;
				height: calc(100% - 5px);
				max-height: 100%;
				iframe {
					width: 100%;
					height: 100%;
					max-height: 100%;
					border: none;
					outline: none;
				}
			}
			
		}
	}
}
</style>
